import { useReactFlow, XYPosition } from '@xyflow/react';
import { RfNodeTextNode, SweepCanvasRfNode } from '../../canvas-types/nodeTypesData';
import { useCanvasFreeElementContext } from '../../canvas-element-tool/CanvasFreeElementContext';
import { getDimensions, getPosition } from '../../canvas-element-tool/helper';
import { CanvasElementType } from '../../canvas-types';
import { useCallback } from 'react';
import { RFEdgeFloatingEdge } from '../../edges/FloatingEdge';
import { TEXT_NODE_MIN_HEIGHT, TEXT_NODE_MIN_WIDTH } from './consts';
import { NODE_Z_INDEX_CREATING } from '../../const/zIndex';

export const useCreateTextNode = () => {
  const { screenToFlowPosition, getViewport, setNodes } = useReactFlow<
    SweepCanvasRfNode,
    RFEdgeFloatingEdge
  >();

  const { setCreateElementActive } = useCanvasFreeElementContext();

  const createTextNode = useCallback(
    (start: XYPosition, end: XYPosition) => {
      const flowPosition = screenToFlowPosition(getPosition(start, end));

      const rawDimensions = getDimensions(start, end, getViewport().zoom);

      setNodes((nodes) => {
        const newTextNodeID = crypto.randomUUID();

        const newTextNode: RfNodeTextNode = {
          id: newTextNodeID,
          type: CanvasElementType.TEXT_NODE,
          position: {
            x: flowPosition.x,
            y: flowPosition.y,
          },
          width: Math.floor(Math.max(rawDimensions.width, TEXT_NODE_MIN_WIDTH)),
          height: Math.floor(Math.max(rawDimensions.height, TEXT_NODE_MIN_HEIGHT)),
          data: {
            richText: '',
            freshlyCreated: true,
            temporary: true,
            textScale: 1,
          },
          zIndex: NODE_Z_INDEX_CREATING,
          selected: true,
          dragHandle: '.drag-handle',
        };

        nodes.unshift(newTextNode);
        return nodes;
      });

      setCreateElementActive(null);
    },
    [screenToFlowPosition, getViewport, setNodes, setCreateElementActive],
  );

  return { createTextNode };
};
